import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { UrlInputFieldWUT } from '../../../ui/url-input-field';
export const UrlInputWUT = (props)=>{
    const fieldType = FIELD_TYPES.URL_INPUT;
    return /*#__PURE__*/ React.createElement(UrlInputFieldWUT, {
        ...props,
        fieldType: fieldType
    });
};

//# sourceMappingURL=url-input-wut.js.map